
export abstract class DigitalSignStartedProcess {
}
